"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var AdminAccessSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M7.20469907,10.4987549 L8.86845322,12.1488213 C9.06174959,12.3405275 9.06303874,12.6526336 8.87133262,12.84593 C8.67619607,13.0410725 8.36249135,13.0421847 8.1674229,12.8498633 L6.49826703,11.2042128 L5.2033214,12.4973727 L6.8684546,14.1488199 C7.06175098,14.3405276 7.0630389,14.652635 6.87133125,14.8459314 C6.6763426,15.040926 6.36274846,15.0416299 6.16832824,14.8489474 L4,12.7 L4,12.3 L8.5549658,7.7387442 C8.20552871,7.24824681 8,6.6481253 8,6 C8,4.34314575 9.34314575,3 11,3 C12.6568542,3 14,4.34314575 14,6 C14,7.65685425 12.6568542,9 11,9 C10.3518747,9 9.75175319,8.79447129 9.2612558,8.4450342 L7.20469907,10.4987549 Z M11,8 C12.1045695,8 13,7.1045695 13,6 C13,4.8954305 12.1045695,4 11,4 C9.8954305,4 9,4.8954305 9,6 C9,7.1045695 9.8954305,8 11,8 Z" })));
};
AdminAccessSmall.displayName = 'AdminAccessSmall';
exports.default = AdminAccessSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=AdminAccessSmall.js.map